export class ValueRangeFilter {
  min?: number;
  max?: number;
  fromValue?: number;
  toValue?: number;
  grid_snap?: number;
  step?: number;
  selected: string[];

  static MockOne(min = 0, max = 100, fromValue = 25, toValue = 78) {
    return { min, max, fromValue, toValue } as ValueRangeFilter;
  }
}
